/**
 * Do not add any JS here, it's loaded in all the pages. Make a dynamic import. @see MATCH-3823 & MATCH-9334
 */

// Vite style load
import '@styles/app.scss';

// Elements
import { initAccordions } from '@components-molecules/accordion';
import deviceDetect from '@tools/device-detect';
import lazy from '@tools/lazyloading';
import { initIntercom } from '@elements/intercom';

// Atoms import
import loadAtoms from '@atoms/load-atoms';

// Molecules import
import banner from '@molecules/banner';
import favoriteBusHandler from '@molecules/favorite-bus-handler';
import proposalBusHandler from '@molecules/proposal-bus-handler';
import sliderManager from '@molecules/slider-manager';

// Organism import
import header from '@organisms/header';
import user from '@organisms/user';

// Pages import
import profileManage from '@pages-old/profile-manage';
import offerPage from '@pages-old/offer';
import createOffer from '@pages-old/create-offer';
import editOffer from '@pages-old/edit-offer';
import vueInit from '@pages-old/vue-init';
import { selectionItemsApp } from '@pages-old/offer/selection-items';
import invoice from '@pages-old/invoice';
import dealDashboard from '@pages-old/deal-dashboard';
import leads from '@pages-old/leads';
import address from '@pages-old/address';
import addressDetails from '@pages-old/address-details';
import adaf from '@pages-old/adaf';
import idealLocation from '@pages-old/ideal-location';
import deobfuscate from '@organisms/deobfuscate';
import offerContactForm from '@pages-old/offer-contact-form';
import guidedSearch from '@pages-old/guided-search';
import officeChooser from '@pages-old/office-chooser';
import onboarding from '@pages-old/organization-onboarding';
import spaceDetails from '@organisms/space-details/space-details';
import staticGoogleMap from '@organisms/page-details/static-google-map';
import pageSpaceContactForm from '@pages-old/page-space-contact-form';
import pageBrand from '@pages-old/page-brand';
import brandDetails from '@organisms/brand-details/brand-details';
import { pagination } from '@atoms/pagination';
import subscriptions from '@pages-old/subscriptions';
import { favoriteButtonLoader } from '@organisms/favoriteButtonLoader';
import nav from './layout/nav.ts';

// Elements
deviceDetect();

// Atoms usage
lazy();
loadAtoms();

// Molecules usage
banner();
favoriteBusHandler();
proposalBusHandler();
// a init que quand necessaire
sliderManager();
user();
deobfuscate();
initAccordions();
onboarding();

// Navigation
nav();

// Organisms usage
header();

profileManage(); // bundle

if (document.querySelector('#home')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "homepage" */ '@organisms/home'
  );
}

if (document.querySelector('.guide-article')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "guide" */ '@pages-old/guide'
  );
}

if (document.querySelector('.carousel')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "carousel" */ '@molecules/carousel'
  );
}

if (document.querySelector('#app-gallery')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "gallery" */ '@organisms/gallery'
  );
}

if (document.querySelector('.footer-columns')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "footer" */ '@organisms/footerFull'
  );
}

if (document.querySelector('#offer-statistics')) {
  // eslint-disable-next-line no-unused-expressions
  import(
    /* webpackChunkName: "statistics" */ '@organisms/offer/statistics'
  );
}
if (document.getElementById('holiday-banner')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "banner" */ '@molecules/holiday-banner.js');
}

if (document.querySelector('.offer-card')) {
  // eslint-disable-next-line import/extensions
  import(/* webpackChunkName: "offer-card" */ '@components-molecules/offer-card');
}

offerPage(); // bundle
createOffer(); // bundle
editOffer(); // bundle
vueInit();
selectionItemsApp(); // bundle
invoice(); // bundle
dealDashboard(); // bundle
leads(); // bundle
subscriptions(); // bundle
address(); // bundle
addressDetails(); // bundle
adaf(); // bundle
idealLocation(); // bundle
offerContactForm();
guidedSearch(); // bundle
officeChooser(); // bundle
spaceDetails(); // bundle
pageBrand(); // bundle
pageSpaceContactForm(); // bundle
staticGoogleMap(); // bundle
brandDetails();
pagination();
favoriteButtonLoader();
initIntercom();
